function reducer(state = [], action) {

  switch (action.type) {
    case 'RIGHTS/SET':      
      return action.rights;
    case 'RIGHTS/CLEAR':
      return null;
    default:
      return state;
  }
}

export default reducer;